module.exports = __webpack_public_path__ + "img/電気回路_4_3.249cfef0.png";